"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

/* eslint-disable */
// Influenced by http://jsfiddle.net/2baax9nk/5/
var Node = function Node(key, data) {
  (0, _classCallCheck2.default)(this, Node);
  this.key = key;
  this.data = data;
  this.previous = null;
  this.next = null;
};

module.exports = /*#__PURE__*/function () {
  function LRU(capacity) {
    (0, _classCallCheck2.default)(this, LRU);
    this.capacity = capacity === 0 ? Infinity : capacity;
    this.map = {};
    this.head = null;
    this.tail = null;
  }

  (0, _createClass2.default)(LRU, [{
    key: "get",
    value: function get(key) {
      // Existing item
      if ((0, _map.default)(this)[key] !== undefined) {
        // Move to the first place
        var node = (0, _map.default)(this)[key];

        this._moveFirst(node); // Return


        return node.data;
      } // Not found


      return undefined;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      // Existing item
      if ((0, _map.default)(this)[key] !== undefined) {
        // Move to the first place
        var _node = (0, _map.default)(this)[key];
        _node.data = value;

        this._moveFirst(_node);

        return;
      } // Ensuring the cache is within capacity


      if ((0, _keys.default)((0, _map.default)(this)).length >= this.capacity) {
        var id = this.tail.key;

        this._removeLast();

        delete (0, _map.default)(this)[id];
      } // New Item


      var node = new Node(key, value);

      this._add(node);

      (0, _map.default)(this)[key] = node;
    }
  }, {
    key: "_add",
    value: function _add(node) {
      node.next = null;
      node.previous = node.next; // first item

      if (this.head === null) {
        this.head = node;
        this.tail = node;
      } else {
        // adding to existing items
        this.head.previous = node;
        node.next = this.head;
        this.head = node;
      }
    }
  }, {
    key: "_remove",
    value: function _remove(node) {
      // only item in the cache
      if (this.head === node && this.tail === node) {
        this.tail = null;
        this.head = this.tail;
        return;
      } // remove from head


      if (this.head === node) {
        this.head.next.previous = null;
        this.head = this.head.next;
        return;
      } // remove from tail


      if (this.tail === node) {
        this.tail.previous.next = null;
        this.tail = this.tail.previous;
        return;
      } // remove from middle


      node.previous.next = node.next;
      node.next.previous = node.previous;
    }
  }, {
    key: "_moveFirst",
    value: function _moveFirst(node) {
      this._remove(node);

      this._add(node);
    }
  }, {
    key: "_removeLast",
    value: function _removeLast() {
      this._remove(this.tail);
    }
  }]);
  return LRU;
}();
//# sourceMappingURL=lru-cache.js.map